import styled from "styled-components";
import parseDate from "../../../../controllers/parseDate";
import { useContext } from "react";
import Context from "../../../../Context";
import contractTypesForEmployee from "../../../../data/employee/contractTypesForEmployee";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import paymentTypes from "../../../../data/employee/paymentTypes";
import dayOfRestTypes from "../../../../data/employee/dayOfRestTypes";
import genderTypes from "../../../../data/employee/genderTypes";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import BubbleTextForDetailData from "../../../customUiForCs/BubbleTextForDetailData";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import employeeShiftTypes from "../../../../data/employee/employeeShiftTypes";
import marriageStatusTypes from "../../../../data/employee/marriageStatusTypes";

const BubbleText = styled.div`
  padding: 10px 25px;
  background-color: var(--surface);
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  /* flex: 2; */

  color: var(--element);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`;

const Container = styled.div`
  padding: 30px 20px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Title = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: var(--elementDim);
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 7px;
`;

// profileImage: item.profileImage,
//     firstName: item.firstName,
//     lastName: item.lastName,
//     email: item.email,
//     dateOfBirth: item.dateOfBirth,
//     gender: item.gender,
//     roleID: item.roleID,
//     registrationNumber: item.registrationNumber,
//     employeeResponsibility: item.employeeResponsibility,
//     phoneNumber: item.phoneNumber,
//     hiringDate: item.hiringDate,
//     contractEndDate: item.contractEndDate,
//     contractType: item.contractType,
//     siteID: item.siteID,
//     shift: item.shift,
//     paymentType: item.paymentType,
//     dayOfRest: item.dayOfRest,
//     cnpsNumber: item.cnpsNumber,
//     baseSalary: item.baseSalary,
//     prime: item.prime,
//     isInsured: item.isInsured,
//     isActive: item.isActive,
//     hasBadge: item.hasBadge,

const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
`;

const SubList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;

  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const PseudoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 800px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export default function DetailsSection({ item }) {
  const { employeeFunctions } = useContext(Context);
  let employeeResponsibility = null;

  if (item.employeeResponsibility) {
    employeeResponsibility = parseDropDownValue({
      query: item.employeeResponsibility,
      theArray: employeeFunctions || contractTypesForSite,
    });
  }

  function renderCustomFields() {
    let defs = item.customFieldDefinitions || [];
    let values = item.customFieldValues || {};

    if (!defs.length) return null;

    return (
      <Container>
        <SubSection>
          <CustomLabel>Champs personnalisés</CustomLabel>
          <SubList>
            {defs.map((field) => {
              let rawVal = values[field.name];
              let displayVal = rawVal;

              if (Array.isArray(rawVal)) displayVal = rawVal.join(", ");
              if (field.type === "date" && rawVal) {
                try {
                  displayVal = parseDate(rawVal);
                } catch (e) {
                  displayVal = rawVal;
                }
              }

              return (
                <BubbleTextForDetailData key={field.name}>
                  {field.name} : {displayVal || "Non renseigné"}
                </BubbleTextForDetailData>
              );
            })}
          </SubList>
        </SubSection>
      </Container>
    );
  }

  return (
    <PseudoContainer>
      <Container>
        <SubSection>
          <CustomLabel>Identité</CustomLabel>
          <SubList>
            <BubbleTextForDetailData>
              Nom : {item.lastName ? item.lastName : "Non"}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData>
              Prenom : {item.firstName ? item.firstName : "Non"}
            </BubbleTextForDetailData>
          </SubList>
          <SubList>
            <BubbleTextForDetailData permissionName="dateOfBirthPermissions">
              Date de naissance : {parseDate(item.dateOfBirth)}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="genderPermissions">
              Genre :{" "}
              {parseDropDownValue({
                query: item.gender,
                theArray: genderTypes,
              })}
            </BubbleTextForDetailData>
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="phoneNumberPermissions">
              Numéro de téléphone : {item.phoneNumber || "Non"}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="cnpsNumberPermissions">
              N° CNPS : {item.cnpsNumber || "Non"}
            </BubbleTextForDetailData>
          </SubList>
        </SubSection>
      </Container>

      <Container>
        <SubSection>
          <CustomLabel>Informations Professionnelles</CustomLabel>
          <SubList>
            <BubbleTextForDetailData permissionName="employeeResponsibilityPermissions">
              Fonction : {employeeResponsibility || "Non"}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="contractTypePermissions">
              Type de contrat :{" "}
              {parseDropDownValue({
                query: item.contractType,
                theArray: contractTypesForEmployee,
              })}
            </BubbleTextForDetailData>
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="hiringDatePermissions">
              Date d'embauche : {parseDate(item.hiringDate)}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="contractEndDatePermissions">
              Date de fin de contrat : {parseDate(item.contractEndDate)}
            </BubbleTextForDetailData>

            {item.departDate ? (
              <BubbleTextForDetailData permissionName="departDatePermissions">
                Date de depart : {parseDate(item.departDate)}
              </BubbleTextForDetailData>
            ) : null}
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="baseSalaryPermissions">
              Salaire de base : {item.baseSalary || "Non"}
            </BubbleTextForDetailData>
            <BubbleTextForDetailData permissionName="primePermissions">
              Prime : {item.prime || "Non"}
            </BubbleTextForDetailData>
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="dayOfRestPermissions">
              Jour de repos :{" "}
              {parseDropDownValue({
                query: item.dayOfRest,
                theArray: dayOfRestTypes,
              })}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="shiftPermissions">
              Shift :{" "}
              {parseDropDownValue({
                query: item.shift,
                theArray: employeeShiftTypes,
              }) || "Non"}
            </BubbleTextForDetailData>
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="paymentTypePermissions">
              Type de paiement :{" "}
              {parseDropDownValue({
                query: item.paymentType,
                theArray: paymentTypes,
              })}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="siteIdPermissions">
              Site : {item.site ? item.site.placeName?.toUpperCase() : "Non"}
            </BubbleTextForDetailData>
          </SubList>

          <SubList>
            <BubbleTextForDetailData permissionName="nationalityPermissions">
              Nationalité : {item.nationality}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="numberOfChildrenPermissions">
              Nombre d'enfants : {item.numberOfChildren}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData permissionName="marriageStatusPermissions">
              Statut matrimonial :{" "}
              {parseDropDownValue({
                query: item.marriageStatus,
                theArray: marriageStatusTypes,
              })}
            </BubbleTextForDetailData>
          </SubList>
        </SubSection>
      </Container>

      <Container>
        <SubSection>
          <CustomLabel>Statut</CustomLabel>

          <SubList>
            <BubbleTextForDetailData permissionName="emailPermissions">
              Email : {item.email ? item.email : "Non"}
            </BubbleTextForDetailData>

            {item.accountType !== "EMPLOYEE" ? (
              <BubbleTextForDetailData permissionName="roleIdPermissions">
                Role : {item.role ? item.role.name : "Non"}
              </BubbleTextForDetailData>
            ) : null}
          </SubList>
          <SubList>
            <BubbleTextForDetailData permissionName="isInsuredPermissions">
              Assuré : {item.isInsured ? "Oui" : "Non"}
            </BubbleTextForDetailData>
            <BubbleTextForDetailData permissionName="isActivePermissions">
              Actif : {item.isActive ? "Oui" : "Non"}
            </BubbleTextForDetailData>
            <BubbleTextForDetailData permissionName="hasBadgePermissions">
              Badge : {item.hasBadge ? "Oui" : "Non"}
            </BubbleTextForDetailData>
          </SubList>
        </SubSection>
      </Container>

      <Container>
        <SubSection>
          <CustomLabel>Contact d'urgence</CustomLabel>
          <SubList>
            <BubbleTextForDetailData>
              Nom et prenom du contact d'urgence :{" "}
              {item.emergencyContactFullName || "Non"}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData>
              Numero de telephone : {item.emergencyContactPhoneNumber || "Non"}
            </BubbleTextForDetailData>

            <BubbleTextForDetailData>
              Lieu de residence : {item.emergencyContactResidence || "Non"}
            </BubbleTextForDetailData>
          </SubList>
        </SubSection>
      </Container>
      {renderCustomFields()}
    </PseudoContainer>
  );
}
